/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable max-len */
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import LinearProgress from '@mui/material/LinearProgress'
import {type AppDispatch, type RootState} from 'redux/store'
import './index.scss'
import {Typography} from '@mui/material'
import LoginForm from './LoginForm'
import CPSAlerts from 'shared/Alerts'
import {Link, useNavigate} from 'react-router-dom'
import {
    fetchAuthToken,
    fetchLoginDetails,
    fetchMenuItem,
    fetchSignOnFilter,
    resetLoginLoading,
    toggleLoginPopup
} from 'features/Login/login.slice'
import {authClient} from 'config/constant'
// import {useEffect, useState} from 'react'
import {checkPasswordExpiryAction} from 'features/ResetPassword/resetPassword.slice'
import {userIdValidation} from 'utils/helperFunctions'
import {ENDPOINT} from 'config/path'
import {fetchNotification, resetNotificationState} from 'features/Notifications/notification.slice'
import {fetchSchedules} from 'features/HomePage/ViewSchedules/viewSchedules.slice'
import {fetchFlightStatus} from 'features/HomePage/FlightStatus/flightstatus.slice'
import {getShipmentDetails} from 'features/HomePage/TrackShipments/trackshipment.action'

import _ from 'lodash'
import {cpsUrl} from 'config/base'
// eslint-disable-next-line
export default function Popup() {
    const login = useSelector((state: any) => state.login)
    const resetPassword = useSelector((state: any) => state.resetPassword)
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const [alertShown, setAlertShown] = useState<boolean>(false)
    const [duplicateAlertShown, setDuplicateAlertShown] = useState<boolean>(false)
    const [isFinalAPI, setIsFinalAPI] = useState<boolean>(false)
    const [SessionTimeout, setSessionTimeout] = useState<boolean>(false)
    const navigateUrl = useSelector((state: RootState) => state.login.navigateUrl)
    const viewScheduleValues = useSelector((state: RootState) => state.login?.viewScheduleData)
    const ViewScheduleFlatten = {...viewScheduleValues}
    // useEffect to handle the operations to be performed after the login process has finished
    useEffect(() => {
        if (!login.isLoading && login.loginDetails && login.authToken && isFinalAPI) {
            const notificationRequest = {
                userId: _.get(login, 'loginDetails.securityParams.userID', ''),
                token: _.get(login, 'authToken.data.access_token', '')
            }
            void dispatch(fetchNotification(notificationRequest))
            void dispatch(fetchMenuItem(login))
        }
    }, [login.isLoading, login.loginDetails, login.authToken, isFinalAPI])

    const getAuthServices = async (values) => {
        const cleanedPath = navigateUrl.replace('/', '')
        const payload = {
            username: values.userID,
            password: values.password,
            ...authClient
        }
        localStorage.setItem('NewLogin', 'true')
        const fetchAndNavigate = (action, payload, navigate, navigateUrl, dispatch) => {
            dispatch(action(payload))
                .then((res) => {
                    navigate(navigateUrl)
                })
                .catch(() => {})
        }
        const apiPayload = userIdValidation(values.userID)
        dispatch(resetNotificationState())
        void dispatch(checkPasswordExpiryAction(apiPayload)).then(async (response: any) => {
            if (!response?.payload?.data?.response?.exist) {
                setAlertShown(true)
            } else if (
                response?.payload?.data?.response?.duplicate === false &&
                response?.payload?.data?.response?.exist === true
            ) {
                const passwordExpired = _.get(response, 'payload.data.response.expired', false)
                const checkIfUserId = {
                    ...payload,
                    passwordExpired
                }
                await dispatch(fetchAuthToken(checkIfUserId))
                    .then((response: any) => {
                        if (response?.payload?.data?.access_token) {
                            if (passwordExpired) {
                                localStorage.setItem('savedUserDetails', values.userID)
                                dispatch(toggleLoginPopup(false))
                                navigate(ENDPOINT.resetPassword)
                            } else {
                                localStorage.setItem('auth', 'true')
                                const payloadAuth = {
                                    newLogin: true,
                                    headers: {
                                        Authorization: `Bearer ${response?.payload?.data?.access_token}`
                                    }
                                }
                                void dispatch(fetchLoginDetails(payloadAuth))
                                    .then(async (response) => {
                                        localStorage.setItem('auth', 'false')
                                        const getEncryptedToken = response?.payload?.securityParams?.encryptedTokenData
                                        if (response?.payload?.securityParams?.encryptedTokenData) {
                                            localStorage.setItem('isLoggedIn', 'true')
                                            void dispatch(fetchSignOnFilter(getEncryptedToken))
                                                .then(async (response) => setIsFinalAPI(true))
                                                .catch((err) => console.error(err))
                                            const userId = response?.payload?.securityParams?.userID
                                            const payload = {...ViewScheduleFlatten, userId}
                                            let endPoints
                                            if (cleanedPath === 'viewSchedules') {
                                                endPoints = fetchSchedules
                                            } else if (cleanedPath === 'viewFlightStatus') {
                                                endPoints = fetchFlightStatus
                                            } else if (cleanedPath === 'trackShipments') {
                                                endPoints = getShipmentDetails
                                            }
                                            fetchAndNavigate(endPoints, payload, navigate, navigateUrl, dispatch)
                                        } else if (response?.payload?.securityParams?.isGuestUser) {
                                            localStorage.setItem('isLoggedIn', 'true')
                                            setIsFinalAPI(true)
                                        }
                                    })
                                    .catch((err) => console.error(err))
                            }
                        }
                    })
                    .catch((err) => console.error(err))
            }
        })
    }

    const handleLoginSubmit = async (values) => {
        await getAuthServices(values)
    }

    const alertMessage = () => (
        <p>
            <strong>Trouble signing in?</strong>&nbsp; Please check your spelling and try again. Otherwise, use&nbsp;
            <Link to={ENDPOINT.forgotPassword}>forgot password</Link> or{' '}
            <a href={`${cpsUrl}${ENDPOINT.contactExistingCPS}`} rel='noreferrer' target='_blank'>
                contact us
            </a>
            .
        </p>
    )

    const duplicateMessage = () => (
        <p>
            <strong>Your email is associated with multiple User IDs.</strong>&nbsp;Please login with your most recent
            User ID instead or{' '}
            <a href={`${cpsUrl}${ENDPOINT.contactExistingCPS}`} rel='noreferrer' target='_blank'>
                contact us
            </a>
            .
        </p>
    )

    const sessionTimeoutMsg = () => (
        <p>
            <strong>Your session expired due to inactivity.</strong>&nbsp;
            <br />
            Please log in if you’d like to continue.
        </p>
    )
    useEffect(() => {
        if (login.error) {
            setAlertShown(true)
            setDuplicateAlertShown(false)
            setSessionTimeout(false)
        }
    }, [login.error])

    useEffect(() => {
        if (resetPassword.duplicate) {
            setAlertShown(false)
            setDuplicateAlertShown(true)
            setSessionTimeout(false)
        }
    }, [resetPassword.duplicate])

    useEffect(() => {
        setAlertShown(false)
        setDuplicateAlertShown(false)
        void dispatch(resetLoginLoading(false))
    }, [])

    useEffect(() => {
        if (localStorage.getItem('sessionTimedOut')?.toLowerCase().includes('true')) {
            localStorage.setItem('sessionTimedOut', 'false')
            setSessionTimeout(true)
            setAlertShown(false)
            setDuplicateAlertShown(false)
        } else {
            setSessionTimeout(false)
        }
    }, [])

    return (
        <>
            {login.isLoading && (
                <div className='loader'>
                    <LinearProgress color='primary' />
                </div>
            )}
            <div className='popup-login-wrapper'>
                <div className='loginFormWrapper'>
                    <Typography variant='h4' className='loginTitle'>
                        Log in
                    </Typography>
                    <div className='loginForm'>
                        {(login.error || resetPassword.error) && alertShown && (
                            <div className='errorBlock'>
                                <CPSAlerts behaviour='fixed' type='error' message={alertMessage()} />
                            </div>
                        )}

                        {resetPassword.duplicate && duplicateAlertShown && (
                            <div className='errorBlock'>
                                <CPSAlerts behaviour='fixed' type='error' message={duplicateMessage()} />
                            </div>
                        )}
                        {SessionTimeout && (
                            <div className='errorBlock'>
                                <CPSAlerts behaviour='fixed' type='error' message={sessionTimeoutMsg()} />
                            </div>
                        )}
                        <LoginForm handleLoginSubmit={handleLoginSubmit} />
                    </div>
                </div>
            </div>
        </>
    )
}
